<mat-card>

  <mat-card-content>

    <!-- Mostra il form solo quando è pronto -->
    <ct-form *ngIf="configuration && isFormReady" [configuration]="configuration"></ct-form>

    <!-- Loader mentre il form si sta caricando -->
    <div *ngIf="!isFormReady" style="text-align: center; padding: 40px;">
      <mat-spinner diameter="40"></mat-spinner>
      <p style="margin-top: 16px; color: #666;">Caricamento form in corso...</p>
    </div>

    <mat-card-actions *ngIf="isFormReady" fxLayout="row wrap" fxLayoutAlign="space-between center">

      <ct-button [configuration]="cancelButton"></ct-button>

      <ct-button [configuration]="submitButton"></ct-button>

    </mat-card-actions>

  </mat-card-content>

</mat-card>
